import { Button } from "@portal/ui";
import { RefreshCw } from "lucide-react";

/** カード内の読み込み中・失敗表示。1カードの失敗で画面全体を壊さない(SPEC §14.2)。 */
export function CardStatus({
  isPending,
  isError,
  refetch,
}: {
  isPending: boolean;
  isError: boolean;
  refetch: () => void;
}) {
  if (isPending) return <p className="text-sm text-muted-foreground">読み込み中…</p>;
  if (isError)
    return (
      <div className="flex flex-col gap-2">
        <p role="alert" className="text-sm text-destructive">
          取得に失敗しました。
        </p>
        <Button variant="outline" size="sm" onClick={refetch}>
          <RefreshCw />
          再読み込み
        </Button>
      </div>
    );
  return null;
}
